import React from 'react';

export const Share = () => (
  <g id="g566">
    <path
      fill="#748498"
      strokeWidth="1.00000012"
      d="m 859.98,0 c -88.32,0 -159.96,72.54 -159.96,162 0,10.2 0.96,20.28 2.88,30.24 L 323.46,416.4 A 158.82,158.82 0 0 0 220.02,378 C 131.64,378 60,450.54 60,540 c 0,89.46 71.64,162 160.02,162 a 158.82,158.82 0 0 0 103.2,-38.52 L 702.9,887.7 a 163.92,163.92 0 0 0 -2.88,30.3 c 0,89.46 71.64,162 159.96,162 88.38,0 160.02,-72.54 160.02,-162 0,-89.46 -71.64,-162 -160.02,-162 -37.8,0 -74.4,13.68 -103.32,38.52 L 377.1,570.24 c 1.92,-9.96 2.88,-20.1 2.88,-30.24 0,-10.2 -0.96,-20.28 -2.88,-30.3 L 756.54,285.6 C 785.46,310.38 822.12,324 859.98,324 948.36,324 1020,251.46 1020,162 1020,72.54 948.36,0 859.98,0 Z"
    />
  </g>
);
